export default class IconItem {
    name: string;
    icon: string;
    otherIcons: IconItem[];
    shouldShow: boolean;
    enabled: boolean;
    selected: boolean;
    hideMenu: (() => void) | undefined;
    button: HTMLButtonElement | undefined;
    translation: string;
    // External side-effect callbacks (toggle the map layer etc.). Kept as fields;
    // the selected-state mutation lives in the methods below so it runs through the
    // Vue 3 reactive proxy (`this` = the reactive instance at call time). When these
    // were arrow functions assigned in the constructor they captured the raw (pre-proxy)
    // instance, so `this.selected = ...` bypassed reactivity and the icon only updated
    // on the next unrelated re-render (e.g. a mouse hover).
    private onSelect: (() => void);
    private onDeselect: (() => void);

    constructor(name: string, icon: string, description: string, select: (() => void), deselect: (() => void), otherIcons: IconItem[], shouldShow: boolean = true, enabled: boolean = true, selected: boolean = false) {
        this.name = name;
        this.icon = icon;
        this.onSelect = select;
        this.onDeselect = deselect;
        this.otherIcons = otherIcons;
        this.shouldShow = shouldShow;
        this.enabled = enabled;
        this.selected = selected;
        this.translation = "message." + description;
    }

    public select(): void {
        this.selected = true;
        if (this.button) this.button.classList.add("tbdc-icon-menu-icon-selected");
        this.onSelect();
    }

    public deselect(): void {
        this.selected = false;
        if (this.button) this.button.classList.remove("tbdc-icon-menu-icon-selected");
        this.onDeselect();
    }

    public hide(): void {
        this.deselect();
        if (this.hideMenu) {
            this.hideMenu();
        }
    }

    public static GetDissabled() {
        return new IconItem("icon-item-dissabled", "", "", () => { }, () => { }, [], false, false)
    }


    public equals(other: IconItem): boolean {
        return this.name == other.name;
    }
}
